<template>
  <div class="default-layout">
    <AppSidebar />
    
    <!-- Overlay para cerrar sidebar al hacer click fuera -->
    <div 
      v-if="sidebarOpen && isMobile"
      class="sidebar-overlay"
      @click="closeSidebar"
    ></div>

    <div class="layout-content">
      <main class="main-content-full" :class="{ scrollable: !isChatPage }">
        <slot />
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppSidebar from '@/components/AppSidebar.vue'
import { useSidebar } from '@/composables/useSidebar'
import { useResponsive } from '@/composables/useResponsive'

const { sidebarWidth, sidebarOpen, closeSidebar } = useSidebar()
const { isMobile } = useResponsive()
const route = useRoute()

const isChatPage = computed(() => route.name === 'chat')
</script>

<style scoped src="@/assets/styles/layouts/FullLayout.css"></style>